export default {
    listagem: {
        titulo_pagina: 'List of States',
        novo: 'Add New State',
        table: {
            empty: "No State Found",
            editar: "Edit",
            nome: "Name"
        },
        filtro: {
            nome: "Name"
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Create New State',
            editar: 'Edit State'
        },
        fields: {
            nome: {
                label: 'Name',
                description: 'State Name'
            },
            status: {
                label: 'Status',
                description: 'State Active or Inactive Status'
            },
            botao_salvar : 'Save State'
        },
        create: {
            success: "State Created Successfully!",
            error: "Error Creating State!"
        },
        update: {
            success: "Status Edited Successfully!",
            error: "Error Editing State!"
        }
    }
}
